"use client";

import React from "react";
import styles from "./css/orderItemCard.module.css";

export default function OrderItemCard({ name, qtyLabel, amount }) {
  return (
    <div className={styles.card}>
      <div className={styles.main}>
        <div className={styles.textBlock}>
          <p className={styles.name}>{name}</p>
          <p className={styles.qty}>{qtyLabel}</p>
        </div>
        <div className={styles.amount}>R {amount.toFixed(2)}</div>
      </div>
    </div>
  );
}
